document.addEventListener("DOMContentLoaded", () => {
  // ------- DOM refs -------
  const headerBar = document.querySelector("header");
  const navbar = document.querySelector(".navbar");

  const searchIcon = document.querySelector(".navbar__icon--search");
  const userIcon = document.querySelector(".navbar__icon--user");
  const cartIcon = document.querySelector(".navbar__icon--cart");
  const burger = document.querySelector(".navbar__burger");
  const searchPanel = document.querySelector(".navbar__search");
  const userMenu = document.querySelector(".navbar__user-menu");
  const cartMenu = document.querySelector(".navbar__cart");

  const mobileToggle = document.getElementById("mobileMenuToggle");
  const navMenu = document.querySelector(".navbar__menu");
  const productsTrigger = document.getElementById("productsMegaMenu");
  const megaMenu =
    document.querySelector(".productsMegaMenu") ||
    document.querySelector(".productMegaMenu");
  const productsLink = productsTrigger
    ? productsTrigger.querySelector("a")
    : null;

  // ------- helpers -------
  const isHoverDevice = () =>
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  const isMobileLike = () =>
    !isHoverDevice() || window.matchMedia("(max-width: 1024px)").matches;

  // Scroll lock (for mobile menu / mega menu; can be reused for cart)
  const ScrollLock = (() => {
    let locked = false;
    let lastY = 0;
    const sbw = () => window.innerWidth - document.documentElement.clientWidth;

    const lock = () => {
      if (locked) return;
      locked = true;
      lastY = window.scrollY || document.documentElement.scrollTop || 0;
      const w = sbw();
      if (w > 0) document.body.style.paddingRight = `${w}px`;
      document.body.style.top = `-${lastY}px`;
      document.body.classList.add("scroll-lock");
    };

    const unlock = () => {
      if (!locked) return;
      locked = false;
      document.body.classList.remove("scroll-lock");
      document.body.style.paddingRight = "";
      const y = lastY;
      document.body.style.top = "";
      window.scrollTo(0, y);
    };

    return { ensure: (should) => (should ? lock() : unlock()) };
  })();

  const isAnyMenuOpen = () =>
    navMenu?.classList.contains("is-open") ||
    megaMenu?.classList.contains("is-open");
  const syncScrollLock = () => ScrollLock.ensure(isAnyMenuOpen());

  const setExpandedProducts = (on) => {
    if (!productsTrigger) return;
    productsTrigger.setAttribute("aria-haspopup", "true");
    productsTrigger.setAttribute("aria-expanded", on ? "true" : "false");
    productsLink?.setAttribute("aria-expanded", on ? "true" : "false");
  };

  const openMega = () => {
    if (!megaMenu) return;
    megaMenu.classList.add("is-open");
    setExpandedProducts(true);
    syncScrollLock();
  };
  const closeMega = () => {
    if (!megaMenu) return;
    megaMenu.classList.remove("is-open");
    setExpandedProducts(false);
    syncScrollLock();
  };

  const toggleNavMenu = (forceOpen) => {
    if (!navMenu) return;
    const open =
      typeof forceOpen === "boolean"
        ? forceOpen
        : !navMenu.classList.contains("is-open");
    navMenu.classList.toggle("is-open", open);
    navbar?.classList.toggle("navbar--mobile-open", open);
    mobileToggle?.setAttribute("aria-expanded", open ? "true" : "false");
    if (!open) closeMega();
    syncScrollLock();
  };

  const forceCloseMainMenus = () => {
    if (navMenu?.classList.contains("is-open")) {
      navMenu.classList.remove("is-open");
      navbar?.classList.remove("navbar--mobile-open");
      mobileToggle?.setAttribute("aria-expanded", "false");
    }
    if (megaMenu?.classList.contains("is-open")) {
      closeMega();
    } else {
      syncScrollLock();
    }
  };

  const closeAllPanelsExcept = (keep) => {
    if (keep !== "search") navbar?.classList.remove("navbar--search-active");
    if (keep !== "user") userMenu?.classList.remove("open");
    if (keep !== "cart") cartMenu?.classList.remove("open");
  };

  // ------- Search / User toggles -------
  if (searchIcon) {
    searchIcon.addEventListener("click", (e) => {
      e.preventDefault();
      const willOpen = !navbar?.classList.contains("navbar--search-active");
      closeAllPanelsExcept("search");
      if (isMobileLike()) forceCloseMainMenus();
      if (willOpen) navbar?.classList.add("navbar--search-active");
      searchPanel?.querySelector("input")?.focus();
    });
  }

  if (userIcon) {
    userIcon.addEventListener("click", (e) => {
      e.preventDefault();
      const willOpen = !userMenu?.classList.contains("open");
      closeAllPanelsExcept("user");
      if (isMobileLike()) forceCloseMainMenus();
      if (willOpen) userMenu?.classList.add("open");
    });
  }

  // =========================
  // CART MENU — Refactored
  // =========================
  if (cartMenu) {
    cartMenu.setAttribute("role", "dialog");
    cartMenu.setAttribute("aria-modal", "true");
    cartMenu.setAttribute("aria-hidden", "true");
  }
  if (cartIcon) {
    cartIcon.setAttribute("aria-controls", "navbarCartMenu");
    cartMenu && !cartMenu.id && (cartMenu.id = "navbarCartMenu");
    cartIcon.setAttribute("aria-expanded", "false");
  }

  const CART_LOCKS_SCROLL = false;
  let lastFocusedBeforeCart = null;

  const openCart = () => {
    if (!cartMenu) return;
    closeAllPanelsExcept("cart");
    if (isMobileLike()) forceCloseMainMenus();

    lastFocusedBeforeCart = document.activeElement;
    cartMenu.classList.add("open");
    cartIcon?.setAttribute("aria-expanded", "true");
    cartMenu.setAttribute("aria-hidden", "false");

    if (CART_LOCKS_SCROLL) ScrollLock.ensure(true);

    const focusable = cartMenu.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    (focusable || cartMenu).focus({ preventScroll: true });
  };

  const closeCart = () => {
    if (!cartMenu) return;
    cartMenu.classList.remove("open");
    cartIcon?.setAttribute("aria-expanded", "false");
    cartMenu.setAttribute("aria-hidden", "true");
    if (CART_LOCKS_SCROLL) ScrollLock.ensure(isAnyMenuOpen());

    if (
      lastFocusedBeforeCart &&
      document.body.contains(lastFocusedBeforeCart)
    ) {
      lastFocusedBeforeCart.focus({ preventScroll: true });
    } else {
      cartIcon?.focus({ preventScroll: true });
    }
  };

  const toggleCart = () => {
    if (!cartMenu) return;
    cartMenu.classList.contains("open") ? closeCart() : openCart();
  };

  if (cartIcon) {
    cartIcon.addEventListener("click", (e) => {
      e.preventDefault();
      toggleCart();
    });
  }

  // Close triggers INSIDE the cart (ID or class)
  if (cartMenu) {
    cartMenu.addEventListener("click", (e) => {
      const trigger = e.target.closest("#closeCartMenu, .closeCartMenu");
      if (trigger && cartMenu.classList.contains("open")) {
        e.preventDefault();
        closeCart();
      }
    });
  }

  // Keyboard a11y for close triggers (Enter/Space)
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Enter" && e.key !== " ") return;
    const trigger = e.target.closest("#closeCartMenu, .closeCartMenu");
    if (trigger && cartMenu?.classList.contains("open")) {
      e.preventDefault();
      closeCart();
    }
  });

  // Outside click to close cart (pointerdown = faster on touch)
  document.addEventListener("pointerdown", (e) => {
    if (!cartMenu?.classList.contains("open")) return;
    const clickInsideCart = cartMenu.contains(e.target);
    const clickOnTrigger =
      cartIcon && (e.target === cartIcon || cartIcon.contains(e.target));
    if (!clickInsideCart && !clickOnTrigger) {
      closeCart();
    }
  });

  // ------- Mobile Navbar toggles (burger + dedicated toggle) -------
  if (burger) {
    burger.addEventListener("click", (e) => {
      e.preventDefault();
      toggleNavMenu();
      if (navMenu?.classList.contains("is-open")) closeAllPanelsExcept(null);
    });
  }

  if (mobileToggle && navMenu) {
    if (!navMenu.id) navMenu.id = "navbarMenu";
    mobileToggle.setAttribute("aria-controls", navMenu.id);
    mobileToggle.setAttribute("aria-expanded", "false");
    mobileToggle.addEventListener("click", (e) => {
      e.preventDefault();
      toggleNavMenu();
      if (navMenu?.classList.contains("is-open")) closeAllPanelsExcept(null);
    });
  }

  // ------- Products Mega: desktop hover, mobile tap -------
  if (productsTrigger && megaMenu) {
    const toggleMegaMobile = (e) => {
      if (isHoverDevice()) return;
      e?.preventDefault();
      megaMenu.classList.toggle("is-open")
        ? setExpandedProducts(true)
        : setExpandedProducts(false);
      syncScrollLock();
      if (megaMenu.classList.contains("is-open")) closeAllPanelsExcept(null);
    };

    let hoverInside = false;
    let closeTimer = null;
    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        if (!hoverInside) closeMega();
      }, 120);
    };
    const onEnter = () => {
      if (!isHoverDevice()) return;
      hoverInside = true;
      clearTimeout(closeTimer);
      openMega();
      closeAllPanelsExcept(null);
    };
    const onLeave = () => {
      if (!isHoverDevice()) return;
      hoverInside = false;
      scheduleClose();
    };

    productsTrigger.addEventListener("mouseenter", onEnter);
    productsTrigger.addEventListener("mouseleave", onLeave);
    megaMenu.addEventListener("mouseenter", onEnter);
    megaMenu.addEventListener("mouseleave", onLeave);

    productsLink?.addEventListener("focus", onEnter);
    productsLink?.addEventListener("blur", onLeave);

    productsTrigger.addEventListener("click", toggleMegaMobile, {
      passive: false,
    });
    productsLink?.addEventListener("click", toggleMegaMobile, {
      passive: false,
    });
    productsTrigger.addEventListener("touchend", toggleMegaMobile, {
      passive: false,
    });

    document.addEventListener("click", (e) => {
      const backBtn = e.target.closest(".menuBack");
      if (backBtn && megaMenu.classList.contains("is-open")) closeMega();
    });

    document.addEventListener("pointerdown", (e) => {
      if (
        megaMenu.classList.contains("is-open") &&
        !megaMenu.contains(e.target) &&
        !productsTrigger.contains(e.target)
      ) {
        closeMega();
      }
    });
  }

  // ------- Close small panels on outside click -------
  document.addEventListener("click", (e) => {
    if (!navbar) return;

    const clickedInsideNavbar = navbar.contains(e.target);
    const clickedInsideCart = cartMenu?.contains(e.target);
    const clickedInsideUser = userMenu?.contains(e.target);
    const clickedInsideSearch = searchPanel?.contains(e.target);
    const clickedInsideMega = megaMenu?.contains(e.target);

    const clickedInsideAnyPanel =
      clickedInsideNavbar ||
      clickedInsideCart ||
      clickedInsideUser ||
      clickedInsideSearch ||
      clickedInsideMega;

    if (!clickedInsideAnyPanel) {
      navbar.classList.remove("navbar--search-active");
      userMenu?.classList.remove("open");
      cartMenu?.classList.remove("open");
    }
  });

  // ------- ESC to close everything -------
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      navbar?.classList.remove("navbar--search-active");
      userMenu?.classList.remove("open");
      if (cartMenu?.classList.contains("open")) closeCart();
      navMenu?.classList.remove("is-open");
      navbar?.classList.remove("navbar--mobile-open");
      closeMega();
      syncScrollLock();
    }
  });

  // ------- Sticky header -------
  if (headerBar) {
    const onScroll = () => {
      if (window.scrollY > 0) headerBar.classList.add("sticky");
      else headerBar.classList.remove("sticky");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  // ------- Keep scroll lock in sync on pointer-capability change -------
  const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
  mq.addEventListener?.("change", () => syncScrollLock());
});

// Standalone burger toggle (as in your original)
document.addEventListener("click", (e) => {
  const btn = e.target.closest(".burger");
  if (!btn) return;
  const isOpen = btn.getAttribute("data-state") === "open";
  btn.setAttribute("data-state", isOpen ? "closed" : "open");
  btn.setAttribute("aria-expanded", String(!isOpen));
  btn.setAttribute("aria-label", isOpen ? "Open menu" : "Close menu");
});
